import { RevenueReportToolbar } from '../../reports-components/RevenueReportToolbar';

type UnmeteredEventsReportToolbarProps = {
  fromDate: Date;
  toDate: Date;
  onFromDateChange: (date: Date | null) => void;
  onToDateChange: (date: Date | null) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onExport: () => void;
};

export const UnmeteredEventsReportToolbar: React.FC<UnmeteredEventsReportToolbarProps> = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  searchValue,
  onSearchChange,
  onExport,
}) => (
  <RevenueReportToolbar
    onSearchChange={onSearchChange}
    searchValue={searchValue}
    searchLabel="Search"
    searchPlaceholder="Search by Customer or Event"
    fromDate={fromDate}
    onFromDateChange={onFromDateChange}
    toDate={toDate}
    onToDateChange={onToDateChange}
    useDateRangePicker
    hideFilters
    hideChartToggle
    onExport={onExport}
  />
);
